import React, { Component } from 'react';

import {URL} from './configuration-manager';


export class FooterBarComponent extends Component {
	
	didSelectLinkAffiliatesButton() {
		window.location = URL.searchLinkAffiliate();
	}

	didSelectPrivacyPolicyButton() {
		window.location = URL.privacyPolicyDetails();
	}

	render() {
		return (
			<div className="footer-bar">
			<div className="content-box">
				Copyright (c) 2020 Aurvan Technologies. All rights reserved.
				&nbsp;&nbsp;|&nbsp;&nbsp; <span className="footer-bar-link" onClick={this.didSelectLinkAffiliatesButton}>Link Affiliates</span>
				&nbsp;&nbsp;|&nbsp;&nbsp; <span className="footer-bar-link" onClick={this.didSelectPrivacyPolicyButton}>Privacy Policy</span>
			</div>
		</div>
		)
	}

 }

 export default FooterBarComponent;